import { createFileRoute, Navigate, redirect } from "@tanstack/react-router";
import { HeroSection } from "@/components/marketing/sections/hero-section";
import { FeaturesListSection } from "@/components/marketing/sections/features-list-section";
import { FeaturedCourseSection } from "@/components/marketing/sections/featured-course-section";
import { AccessibilitySection } from "@/components/marketing/sections/accessibility-section";
import { TestimonialSection } from "@/components/marketing/sections/testimonial-section";
import { useAuthStore } from "@/stores/authStore";
import { REDEEM_PATH, takeResumeRedeemAfterSignOut } from "@/features/seat-orders/redeemCode";

export const Route = createFileRoute("/_marketing/")({
  // Signing out returns here (WorkOS's logout comes back to the site root). After "Not you? Sign out" on Confirm
  // enrolment, go back to the invite so the right person can sign in and confirm it (LMS-188).
  beforeLoad: () => {
    if (takeResumeRedeemAfterSignOut()) {
      throw redirect({ to: REDEEM_PATH, replace: true });
    }
  },
  component: Home,
});

function Home() {
  const { isAuthenticated, isLoading, isInitialized } = useAuthStore();

  // Redirect authenticated users to my-learning dashboard
  if (isInitialized && !isLoading && isAuthenticated) {
    return <Navigate to="/my-learning" />;
  }

  // Grounds alternate surface / white, then the navy testimonial; the layout's Footer adds the newsletter.
  return (
    <>
      <HeroSection />
      <FeaturesListSection />
      <FeaturedCourseSection />
      <AccessibilitySection heading="Easy to use, for everyone" intro={null} />
      <TestimonialSection />
    </>
  );
}
